export { commonServer } from './server/common.js'
export { fileServer } from './server/upload.js'
export { UserServer, courseServer, rptTemplateServer, keyServer } from './server/system.js'
export { questionServer, vedioServer, coursewareServer, caseServer, packgeServer, resourceServer } from './server/resource.js'
export { classServer, studentServer, classAnalysisServer, studentCenterServer } from './server/class.js'
export { analysisServer } from './server/analysis.js'
export { readServer, readExamServer, sparkQuestionServer, sparkFileServer, sparkSystemServer } from './server/paper.js'



// WEBPACK FOOTER //
// ./src/api/api.js